import React from "react";
import { useTranslation } from "react-i18next";
import WarningIcon from "../../assets/images/warning.svg";
import ThankYouIcon from "../../assets/images/success.svg";
import { useDashboardContext } from "../../context/customhook/dashboardHook";
import { appConstants } from "../../utils/constants";
import ShukranIcon from "../../assets/images/shukran.svg";
import {
  appStoreUrlMap,
  playStoreUrlMap,
  webUrlMap,
} from "../../utils/concept-enum";
export default function Success() {
  const { t } = useTranslation();
  const { dashboardStates } = useDashboardContext();

  /**
   * Open New tab and navigate to platform specific URL
   */
  const openInNewTab = (url) => {
    window.open(url);
  };

  /**
   * If Customer using iPhone NPS link will navigate to App Store with Concept Specific App
   */
  function getAppStoreUrl() {
    let concept = parseInt(localStorage.getItem(appConstants.conceptCode), 10);
    return appConstants.AppStore + appStoreUrlMap.get(concept);
  }

  /**
   * If Customer using Android Phone NPS link will navigate to Play Store with Concept Specific App
   */
  function getPlayStoreUrl() {
    let concept = parseInt(localStorage.getItem(appConstants.conceptCode), 10);
    return appConstants.PlayStore + playStoreUrlMap.get(concept);
  }

  /**
   * If Customer using Web  NPS link will navigate to Concept Specific Web Page
   */
  function getWebUrl() {
    let concept = parseInt(localStorage.getItem(appConstants.conceptCode), 10);
    return webUrlMap.get(concept);
  }

  return (
    <div className="error-container">
      <img
        src={
          dashboardStates.isSubmittedMessage === appConstants.alreadyRated
            ? WarningIcon
            : ThankYouIcon
        }
        alt="logo"
        className="thankyou-img"
      />
      <label className="recommendation">
        {t(dashboardStates.isSubmittedMessage)}
      </label>

      {!dashboardStates.isSourceWeb && (
        <div className="md-px-8 my-3">
          <button
            id="continue-shopping"
            className="bg-cp hover:bg-[#0c86b3] hover:border-[#0c86b3] h-14 px-10 py-3 w-full text-white font-semibold border-[#1EB9E3] border-2 rounded-[6px]"
            onClick={() =>
              openInNewTab(
                /**
                 * navigator.userAgent to identify Platform
                 */
                navigator.userAgent.includes(appConstants.ios)
                  ? getAppStoreUrl()
                  : navigator.userAgent.includes(appConstants.android)
                  ? getPlayStoreUrl()
                  : getWebUrl()
              )
            }
          >
            {t("shoppingExperience")}
          </button>

          <button
            type="button"
            className="inline-flex items- w-full h-14 bg-white hover:bg-yellow-50 border-[#C19F63] border-2 justify-center text-[#C19F63] font-semibold px-2 py-3 rounded-[6px] my-4"
            onClick={() => openInNewTab(appConstants.shukranUrl)}
          >
            <img className="px-2" src={ShukranIcon} alt="shukran" />
            {t("loginShukran")}
          </button>
        </div>
      )}
    </div>
  );
}
